import axios from "axios"
import { saveAs } from "file-saver"

const request = (method, path, data, responseType) => axios({ method, url: `/api/accounting/alibey-bills${path}`, data, responseType,
  timeout: 30000, headers: { Authorization: localStorage.getItem("token") } }).then(response => response.data)

async function saveFile(blob, filename, extension) {
  if (window.flutter_inappwebview) {
    const base64 = await new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onerror = () => reject(new Error("Die Datei konnte nicht gelesen werden."))
      reader.onload = () => resolve(String(reader.result).split(",")[1])
      reader.readAsDataURL(blob)
    })
    await window.flutter_inappwebview.callHandler("blobToBase64Handler", base64, extension, filename)
  } else saveAs(blob, `${filename}.${extension}`)
}

export default {
  alibeyBills: {
    fetch: () => request("get", "/"),
    createFlight: data => request("post", "/flights", data),
    updateFlight: (id, data) => request("put", `/flights/${encodeURIComponent(id)}`, data),
    update: (id, data) => request("put", `/${encodeURIComponent(id)}/booking`, data),
    hotel: (id, data) => request("put", `/${encodeURIComponent(id)}/hotel`, data),
    create: (id, data) => request("post", `/${encodeURIComponent(id)}/invoice`, data),
    status: (id, data) => request("put", `/${encodeURIComponent(id)}/status`, data),
    remove: (id, data) => request("delete", `/${encodeURIComponent(id)}`, data),
    async exportList(data, name) {
      const { default: writeXlsxFile } = await import("write-excel-file")
      const rows = data.map((row, index) => row.map(value => ({ value: value == null ? "" : value,
        type: typeof value === "number" ? Number : String, fontSize: 12, wrap: true,
        ...(index === 0 ? { fontWeight: "bold", backgroundColor: "#E5F3E9" } : {}) })))
      const blob = await writeXlsxFile(rows, { columns: data[0].map((label, index) => ({ width: index === 1 ? 28 : label.includes("Bemerkungen") ? 45 : 22 })) })
      await saveFile(blob, `Alibey_${name}_${new Date().toISOString().slice(0, 10)}`, "xlsx")
    },
    async download(id, number) {
      const blob = await request("get", `/${encodeURIComponent(id)}/pdf`, null, "blob")
      await saveFile(blob, `Alibey_${number}`, "pdf")
    },
  },
}
